import { Observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { BaseCampaign } from '@feathr/blackbox';
import type { IColumn } from '@feathr/components';
import { TableColumnHeader } from '@feathr/components';

import * as tableStyles from '@feathr/components/dist/Table/Table.css';

const EmailUniqueClicksColumn: IColumn<BaseCampaign> = {
  id: 'stats__num_clicks_new',
  checkboxLabel: 'Unique Clicks',
  Header: TableColumnHeader({
    title: 'Unique Clicks',
  }),
  width: 110,
  sortable: false,
  className: tableStyles.cellRight,
  Cell({ original }): JSX.Element {
    return (
      <Observer>
        {(): JSX.Element => {
          const stats = original.get('stats_cache');
          const uniqueClicks = stats?.num_clicks_new || 0;
          return <>{uniqueClicks.toLocaleString()}</>;
        }}
      </Observer>
    );
  },
  Footer({ data }): JSX.Element {
    return (
      <Observer>
        {(): JSX.Element => {
          const total = data.reduce((subtotal, currentValue) => {
            const stats = currentValue._original.get('stats_cache');
            const uniqueClicks = stats?.num_clicks_new || 0;
            return subtotal + uniqueClicks;
          }, 0);
          return <>{total.toLocaleString()}</>;
        }}
      </Observer>
    );
  },
};

export default EmailUniqueClicksColumn;
